import * as yup from 'yup';
import { PHONE_NUMBER_REGEX } from 'src/constants';

const commonScheme = {
  required: yup.string().required('This is a required field'),
  name: yup.string().required('Name is required'),
  email: yup.string().email('Invalid email address').required('Email is required'),
  password: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .max(12, 'Password must not exceed 12 characters')
    .required('Password is required'),
  passwordConfirmation: yup
    .string()
    .min(6, 'Password must be at least 6 characters')
    .max(12, 'Password must not exceed 12 characters')
    .required('Password is required')
    .oneOf([yup.ref('password'), null], 'Password must match'),
};

export const signinFormScheme = yup.object().shape({
  email: commonScheme.email,
  password: commonScheme.password,
});
export const joinFormScheme = yup.object().shape({
  email: commonScheme.email,
  name: commonScheme.name,
  password: commonScheme.password,
  confirmPassword: commonScheme.passwordConfirmation,
  phoneNumber: yup.string().matches(PHONE_NUMBER_REGEX, 'Invalid phone number').required('Phone Number is required'),
  workDays: yup.array().required('Work days is required'),
  vanSize: yup.string().required('Van size is required'),
  vanReg: yup.string().required('Van registration is required'),
  vanMake: yup.string().required('Van make is required'),
  vanModel: yup.string().required('Van model is required'),
  vanColor: yup.string().required('Van color is required'),
  based: yup.string().required('Based city is required'),
  publicLiability: yup.mixed().required('Public liability file is required'),
  goodsInTransit: yup.mixed().required('Goods in transit file is required'),
  vanInsurance: yup.mixed().required('Van insurance file is required'),
  insuranceExpires: yup.mixed().required('Insurance expire date is required'),
});
export const updateUserSchema = yup.object().shape({
  status: commonScheme.required,
});

export const addUserSchema = yup.object().shape({
  email: commonScheme.email,
  role: commonScheme.required,
  status: yup.string(),
});
